<template>
    <div class="home">
        <div class="fade-when-loading home__main-table">
            <div class="no-data" v-if="sortedTableData.length === 0">
                No results.
                <v-button
                    :customLabel="'Clear filters.'"
                    @click="filterRcdc(true)" />
            </div>
            <v-table
                :tableName="'mainTable'"
                :customId="'main-data-table'"
                :customClass="'data-table'"
                :tableData="sortedTableData"
                :columns="filteredTableColumns"
                :sortField.sync="sortField"
                :sortDir.sync="sortDir"
                @click="rowClick"
                @filter="filterRcdc"
                ref="dataTable"
            />
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import globalMixins from '@/js/globalMixins';
import { isProxy, toRaw  } from 'vue';
import bus from '@/js/event-bus.js';

export default {
    name: 'Home',
    mixins: [globalMixins],
    computed: {
        ...mapGetters([
            'yearsData',
            'loadingNewData',
            'yearsData',
            'selectedIc',
            'selectedIcFilter',
            'selectedYear',
            'selectedFacet',
            'tableColumns',
            'singleStudiesFilter',
            'selectedRcdc',
            'rcdcFilterValue',
            'parsedAndFilteredData',
            'columnView'
        ]),
        filteredTableColumns: function () {
            if (this.columnView === 'detail') {
                return this.tableColumns;
            } else {
                return this.tableColumns.filter(x => (x.colName === 'rcdc' || x.colName.indexOf('median-') !== -1));
            }
        }
    },
    mounted () {
        this.setColumns();
        bus.$on('setTableData', () => {
            this.setTableData();
        });
        this.parseAndFilterRawData().then(() => {
            this.setTableData();
        });
        bus.$on('update:sortDir', (sortDir) => { 
            this.sortDir = sortDir;
        });
        bus.$on('update:sortField', (sortField) => {
            this.sortField = sortField;
        });
        bus.$on('row:click', (data) => {
            this.rowClick(data);
        });
    },
    data: function () {
        return {
            tableData: [],
            sortField: 'rcdcCategory',
            sortDir: 'asc',
            timer: 0
        };
    },
    methods: {
        ...mapActions([
            'setTableColumns',
            'setLoadingNewData',
            'setSelectedRcdc',
            'getRCDCData',
            'setAfterFilteringData',
            'parseAndFilterRawData',
            'setSelectedRcdcData',
            'setRcdcFilterValue',
            'setAppInit'
        ]),
        setColumns () {
            this.setTableColumns({data: copyData(window[this.selectedFacet + 'Columns']), route: this.$route}).then(() => {
                if (this.$refs.dataTable) {
                    this.$refs.dataTable.floatTableHeader();
                }
            });
        },
        setTableData () {
            this.tableData = copyData(this.parsedAndFilteredData);

            this.$nextTick(() => {
                this.filterRcdc();

                setTimeout(() => {
                    this.setAppInit(true);
                    this.setLoadingNewData(false);
                }, 301);
            });
        },
        rowClick (proxyObject) {
            if (proxyObject.name) {
                let obj = proxyObject;
                if(isProxy(proxyObject.data)){ //this If() block is not really necessary
                    obj.data = toRaw(proxyObject.data)
                }
                this.setLoadingNewData(true);
                gtag('event','Click', {
                            'event_category': 'RCDC Category: ' + obj.data.rcdcCategory,
                            'event_label': 'Select RCDC Category',
                            'value': obj.data.rcdcCategory
                        });	

                this.setSelectedRcdc(obj.data.rcdcCategory).then(() => {
                    this.getRCDCData().then(() => {
                        if (this.selectedIcFilter !== 'Total, NIH') {
                            this.$router.push({
                                path: 'ic',
                                query: {
                                    rcdcCategory: obj.data.rcdcCategory,
                                    ic: this.selectedIcFilter,
                                    // fiscalYear: this.selectedYear
                                }
                            });
                        } else {
                            this.$router.push({
                                path: 'rcdc',
                                query: {
                                    rcdcCategory: obj.data.rcdcCategory
                                }
                            });
                        }
                    });
                });
            }
        },
        filterRcdc (clearFilter) {
            var options = {
                    threshold: 0.2,
                    distance: 500,
                    maxPatternLength: 32,
                    minMatchCharLength: 1,
                    keys: [
                        'rcdcCategory'
                    ]
                },
                fuse,
                routerQuery = copyData(this.$route.query),
                path = this.$route.path === '/' ? 'home' : this.$route.path,
                returnedData = [];


            this.setAfterFilteringData(true);

            if (!this.rcdcFilterValue || clearFilter) {
                this.tableData = copyData(this.parsedAndFilteredData);

                if (clearFilter) {
                    this.setRcdcFilterValue('');
                    delete routerQuery.rcdcFilter;

                    this.$router.replace({
                        path: path,
                        query: routerQuery
                    });
                }
            } else {
                fuse = new Fuse(this.parsedAndFilteredData, options);
                returnedData = fuse.search(this.rcdcFilterValue);

                this.tableData = [];
                for(let i = 0; i < returnedData.length; i++) {
                    this.tableData.push(returnedData[i].item);
                }
            }

            this.$nextTick(() => {
                this.$nextTick(() => {
                    if (this.$refs.dataTable) {
                        this.$refs.dataTable.floatTableHeader();
                    }
                    $(this.$el).find('.table-comp__floating-table').floatTableColumn(true);

                    setTimeout(() => {
                        this.setAfterFilteringData(false);
                    }, 1000);
                });
            });
        }
    }
};
</script>

<style lang="scss">

.home__main-table {
    height: 100%;
    position: relative;
    // overflow: auto;

    &.icTable {
        overflow: auto;
    }

    .no-data {
        width: 200px;
        position: absolute;
        top: 150px;
        left: $home-page-padding;
        z-index: 50;

        .custom-btn:not(.nohover):not(.svg-only) {
            background-color: rgba(100,20,20,.15);
            color: #641414;
        }
    }
}
</style>



